import { Module } from '../plugins/_application';
import { distance } from "../utils/_calculate-distance";

export default class SocialShare extends Module {
  ready (app) {

    // Constants
    const socialIconsWrapper = document.querySelector('.social-buttons-wrapper');

    if (!socialIconsWrapper) {
		return;
	}

    const triggerClass = 'show';
    // Variables
    let distanceToSocialWrapper = 0;
    let distanceToNewsWrapper = 0;
    let ticking = false;

    // Function to add or remove the class 'show' from socialIconsWrapper
    function toggleSocialButtons(inPosition) {
        let isVisible = socialIconsWrapper.classList.contains('show');

        if (window.innerWidth > 1200) {
            if (inPosition && !isVisible) {
                socialIconsWrapper.classList.add(triggerClass);
            } else if (!inPosition && isVisible) {
                socialIconsWrapper.classList.remove(triggerClass);
            }
        }
    }

    // Use window.requestAnimationFrame to debounce the scroll listener
    function scrollHandler() {
        distanceToSocialWrapper = distance.toDiv('.social-buttons-wrapper');
        distanceToNewsWrapper = distance.toDiv('#main_footer');

        if (!ticking) {
            window.requestAnimationFrame(function() {
                let inPosition = distanceToSocialWrapper < -15 && distanceToNewsWrapper > 400;
                toggleSocialButtons(inPosition);
                ticking = false;
            });
            
            ticking = true;
        }
    }

    // Function to share on social media
    function socialShare (e) {
        e.preventDefault();

        const href = this.getAttribute('href');
        const network = this.getAttribute('data-network');

        const networks = {
            facebook: { width: 600, height: 300 },
            twitter: { width: 600, height: 254 },
            google: { width: 515, height: 490 },
            linkedin: { width: 600, height: 473 }
        }

        const options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
        window.open(href, '', options + 'height=' + networks[network].height + ',width=' + networks[network].width);
    }

    // Add event listeners on the blog
    if (socialIconsWrapper) {
        window.addEventListener('scroll', scrollHandler);

        // Add event listeners to the social icon class
        let socialIcons = document.querySelectorAll('.social-icon');
        for (let i = 0; i < socialIcons.length; i++) {
            socialIcons[i].addEventListener('click', socialShare);
        }
    }
  }
}
